import React from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {AuthType, UrlPrefix} from '../../../config/constants'
import {useLocale, useQueryObj} from '../../hocs/hooks'
import styles from './CvArea.scss'

const CvArea = () => {
  const hostDocUrl = 'https://share.hsforms.com/18VowgkqoRXOUrVfQxwM4iA3jx43'
  const {loggedIn, isOk} = useSelector(
    ({ session: { loggedIn, user: {isOk} } }: IState) => ({loggedIn, isOk}),
    shallowEqual
  )
  const queryObj = useQueryObj()
  const locale = useLocale()
  const [regObj] = loggedIn && isOk
    ? [`/${locale}${UrlPrefix.host}/car`, 'キャンピングカーを登録する']
    : [queryObj({auth: AuthType.signup}), 'ホルダー登録']
  return <>
  <div className={['d-flex flex-column align-items-center justify-content-center text-center', styles.allCar].join(' ')}>
    <h2 className={styles.title}>
      <div className='d-block d-md-none'>
        {'資料ダウンロード&'} <br />ホスト登録（無料）は<br />こちらから！
      </div>
      <div className='d-md-block d-none'>{'資料ダウンロード&ホスト登録（無料）はこちらから！'}</div>
    </h2>
    <div className='d-flex flex-column flex-md-row m-md-0'>
      <div className={['mr-md-4 mb-3 mb-md-0'].join(' ')}>
        <a href={hostDocUrl} className={['btn btn-primary btn-lg rounded-pill', !loggedIn && !isOk && 'ga-car-share-holder', styles.button].filter(Boolean).join(' ')}>
          資料ダウンロード
        </a>
      </div>
      <div className={[''].join(' ')}>
        <Link to={regObj} className={['btn bg-white btn-lg text-black rounded-pill font-size-15', !loggedIn && !isOk && 'ga-car-share-holder', styles.button, styles.btnWhite].filter(Boolean).join(' ')}>
          ホスト登録
        </Link>
      </div>
    </div>
  </div>
</>

}
CvArea.displayName = 'CvArea'
export default CvArea
